/**
 * Stone Investment Spaces Modal
 *
 * Now redirects to the portal Room Designer.
 * The fullscreen modal was removed in favour of the portal-integrated wizard.
 */

'use client';

import React, { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';

export interface StoneSpacesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const StoneSpacesModal: React.FC<StoneSpacesModalProps> = ({
  isOpen,
  onClose,
}) => {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (!isOpen) return;
    const match = pathname.match(/^\/([a-z]{2})(\/|$)/);
    const locale = match?.[1] ?? 'en';
    onClose();
    router.push(`/${locale}/account/spaces`);
  }, [isOpen, onClose, router, pathname]);

  return null;
};

export default StoneSpacesModal;
